import { render, staticRenderFns } from "./preference-page-translations-tab.vue?vue&type=template&id=f8fe774c"
import script from "./preference-page-translations-tab.vue?vue&type=script&lang=js"
export * from "./preference-page-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports